import {
  Box,
  Button,
  Container,
  FormControl,
  FormControlLabel,
  FormLabel,
  Grid,
  IconButton,
  InputAdornment,
  InputLabel,
  MenuItem,
  Radio,
  RadioGroup,
  Select,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import { DropDownList } from "../Components/DropDownList";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import { useAuth } from "../Components/AuthContext";
import { DialogAlert } from "../Components/DialogAlert";
import { addEspaceCharacters, constantes, instance } from "../Components/config";
import { DatePicker } from "@mui/x-date-pickers";
import CloseIcon from "@mui/icons-material/Close";
import TuneTwoToneIcon from "@mui/icons-material/TuneTwoTone";
import { LoaderBox } from "../Components/LoaderBox";

function RptPresupuestoMenu() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [upse, setUPSE] = useState({});
  const [openDialog, setOpenDialog] = useState(false);
  const [openFilter, setOpenFilter] = useState(false);
  const [tipoDeEje, setTipoDeEje] = useState({ Id: "", Nombre: "" });
  const [eje, setEje] = useState({ Id: "", Nombre: "" });
  const [dialog, setDialog] = useState({
    title: "",
    text: "",
    redirect: false,
    page: "/Actividad",
    pageState: {},
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    const info = e.target;
    let form;
    if (openFilter) {
      form = {
        id: user.id,
        upse: "",
        nombre: addEspaceCharacters(info.nombre.value),
        anio: info.anio.value,
        tipoDeEje: tipoDeEje.Id,
        eje: eje.Id,
        cooperacion: info.cooperacion.value,
        signo: info.signo.value,
        presupuesto: info.presupuesto.value,
      };
    } else {
      form = {
        id: user.id,
        upse: upse.Id,
        nombre: "",
        anio: "",
        tipoDeEje: "",
        eje: "",
        cooperacion: "",
        signo: "",
        presupuesto: "",
      };
    }
    instance
      .post("reporte/presupuesto", form)
      .then((res) => {
        navigate("/RptPresupuesto", {
          state: {
            data: res.data,
            header: !openFilter?(`: ${upse.Nombre}`):"",
          },
        });
      })
      .catch((err) => {
        if (err.response.status === 500) {
          setDialog({
            title: "ERROR",
            text: "Existe algún problema con el servidor, por favor inténtalo de nuevo mas tarde, si el problema persiste contáctate con alguno de los encargados.",
          });
        } else {
          setDialog({ title: "ERROR", text: err.response.data.message });
        }
      })
      .finally(setOpenDialog(true));
  };
  return (
    <LoaderBox>
      <Container
        maxWidth="sm"
        sx={{
          border: { xs: "0", sm: "1px solid #000" },
          mt: 4,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          padding: 2,
        }}
        component="form"
        onSubmit={handleSubmit}
      >
        <Typography variant="h5" sx={{ textDecoration: "underline" }}>
          Reporte de presupuesto ejecutado
        </Typography>

        <Grid container sx={{ display: "flex", flexDirection: "row" }}>
          <Grid
            container
            sx={{ display: openFilter ? "flex" : "none" }}
            spacing={2}
          >
            <Grid item xs={12} sm={12}>
              <TextField
                id="nombre"
                label="Nombre"
                type="search"
                variant="standard"
                fullWidth
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <DatePicker
                views={["year"]}
                margin="standard"
                fullWidth
                id="anio"
                label="Año que planifica"
                name="anio"
                format="YYYY"
              />
            </Grid>
            <Grid
              item
              xs={12}
              sm={6}
              sx={{ display: "flex", justifyContent: "center" }}
            >
              <FormControl>
                <FormLabel>Cooperación Externa</FormLabel>
                <RadioGroup row name="cooperacion">
                  <FormControlLabel
                    value="true"
                    control={<Radio />}
                    label="Sí"
                  />
                  <FormControlLabel
                    value="false"
                    control={<Radio />}
                    label="No"
                  />
                </RadioGroup>
              </FormControl>
            </Grid>
            <Grid
              item
              xs={12}
              sx={{ display: "flex", flexDirection: "row" }}
              gap={2}
            >
              <Grid item xs={2}>
                <FormControl fullWidth>
                  <InputLabel id="signoLabel">Signo</InputLabel>
                  <Select id="signo" name="signo" label="Signo">
                    <MenuItem value="1">=</MenuItem>
                    <MenuItem value="2">{"<="}</MenuItem>
                    <MenuItem value="3">{">="}</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={10}>
                <TextField
                  variant="standard"
                  margin="normal"
                  fullWidth
                  id="presupuesto"
                  label="Techo presupuestario"
                  name="presupuesto"
                  type="number"
                  inputProps={{
                    step: constantes.decimales_dinero,
                    min: 0,
                    style: { textAlign: "right" },
                  }}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">Q</InputAdornment>
                    ),
                  }}
                />
              </Grid>
            </Grid>
            <Grid item xs={12} sm={6}>
              <DropDownList
                title="Tipo de Eje"
                endpoint={"/tipoDeEje/listAll"}
                selectedItem={tipoDeEje}
                setSelectedItem={setTipoDeEje}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <DropDownList
                title="Eje"
                endpoint={
                  tipoDeEje.Id !== ""
                    ? `/eje/allByTipo/${tipoDeEje.Id}`
                    : undefined
                }
                selectedItem={eje}
                setSelectedItem={setEje}
                disabled={tipoDeEje.Id === ""}
                hierarchyUpdated={tipoDeEje}
              />
            </Grid>

            <Grid item xs={12}>
              <Grid
                container
                sx={{
                  alignItems: "center",
                  justifyContent: "center",
                  display: "flex",
                }}
                spacing={4}
              >
                <Grid
                  item
                  xs={6}
                  sx={{
                    alignItems: "center",
                    justifyContent: "center",
                    display: "flex",
                    alignContent: "flex-end",
                  }}
                >
                  <Box>
                    <Button
                      type="submit"
                      size="large"
                      variant="contained"
                      color="success"
                      padding={1}
                    >
                      Generar
                    </Button>
                  </Box>
                </Grid>
                <Grid
                  item
                  xs={6}
                  sx={{
                    alignItems: "center",
                    justifyContent: "center",
                    display: "flex",
                    alignContent: "flex-end",
                  }}
                >
                  <Box>
                    <IconButton onClick={() => setOpenFilter(!openFilter)}>
                      <CloseIcon /> Cerrar Filtros
                    </IconButton>
                  </Box>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          <Grid
            item
            sx={{
              display: openFilter ? "none" : "flex",
              flexDirection: "row",
              gap: 2,
            }}
            xs={12}
          >
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <DropDownList
                  title="UPSE"
                  endpoint={"/upse/listDDLAll"}
                  selectedItem={upse}
                  setSelectedItem={setUPSE}
                />
              </Grid>
              <Grid item xs={6}>
                <Box sx={{ display: "flex", justifyContent: "center" }}>
                  <Button
                    type="submit"
                    size="large"
                    variant="contained"
                    color="success"
                    padding={1}
                  >
                    Generar
                  </Button>
                </Box>
              </Grid>
              <Grid item xs={6}>
                <Box sx={{ display: "flex", justifyContent: "center" }}>
                  <Tooltip title="Filtros">
                    <IconButton onClick={() => setOpenFilter(!openFilter)}>
                      <TuneTwoToneIcon /> Filtros generales
                    </IconButton>
                  </Tooltip>
                </Box>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Container>
      <DialogAlert
        title={dialog.title}
        text={dialog.text}
        open={openDialog}
        setOpen={setOpenDialog}
        redirectOnClose={dialog.redirect}
        page={dialog.page}
        pageState={dialog.pageState}
      />
    </LoaderBox>
  );
}
export { RptPresupuestoMenu };
